import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/libra')({
  component: RouteComponent,
  staticData: {
    title: 'Libra',
  },
})

function RouteComponent() {
  return <Outlet />
}
